<div class="d-none d-lg-block d-xl-block d-xxl-block">
  <div style="background-color: var(--theme-color);">
    <div class="d-flex justify-content-between align-items-center px-5 py-4" style="max-width: 1440px; margin: auto;">
      <a [routerLink]="['/']"><img src="https://s3.ap-southeast-1.amazonaws.com/ecrms-appfiles/homeconfig/configuration/20251212_022718_587.webp" style="max-width: 162px;"  loading="lazy" /></a>
      <div *ngIf="!isAuthenticated">
        <button class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">Đăng nhập</button>
      </div>
    </div>
  </div>

  <div style="max-width: 1440px; margin: auto;">
    <div class="p-5">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="d-flex flex-column justify-content-center gap-5">
            <div style="font-weight: 700; font-size: 64px; line-height: 140%; color: #000000;">
              <div>Chào mừng</div>
              <div>Quý Khách Hàng</div>
              <div>quay trở lại</div>
            </div>
            <div style="font-size: 24px; color: #828282; line-height: 150%;">
              Trải nghiệm <span style="font-weight: 700;">Nhanh chóng – An toàn – Hiệu quả</span> cùng Dược Vương – DV Medking. 
            </div>
            <div>
              <button *ngIf="!isAuthenticated" class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">Đăng nhập</button>
              <button *ngIf="isAuthenticated" class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="receiveReward()" data-cta="landing.welcome_back_claim" data-cta-loc="welcome_back">nhận ưu đãi</button>
            </div>
          </div>
        </div>
        <div>
          <img src="assets/images/landing-page/welcome-back-illustration.png" style="max-height: 519px;"  loading="lazy" />
        </div>
      </div>
    </div>
  </div>

  <div style="padding: 20px 0;">
    <div style="padding: 40px 48px; background-color: var(--theme-color)26; border: 1px solid var(--theme-color)4D; font-size: 24px; line-height: 140%; font-style: italic; text-align: center">
      <div class="px-5" style="max-width: 1440px; margin: auto;">
        Dược Vương - DV MedKing xin gửi lời tri ân chân thành đến Quý khách hàng, những người đã đồng hành, tin tưởng và trao cho chúng tôi cơ hội được phục vụ để cùng nhau lan tỏa sức khỏe và niềm vui đến cộng đồng. Với khát vọng mang đến cho Quý vị những giá trị vượt xa mong đợi, DV MedKing hôm nay đã nhanh hơn, an toàn hơn, hiệu quả hơn.
      </div>
    </div>
  </div>

  <div style="padding: 40px 48px; display: flex; justify-content: center; font-size: 24px; font-weight: 500; line-height: 130%;">
    Như một lời tri ân dành cho Quý Khách Hàng, DV MedKing cam kết: 
  </div>

  <div class="d-flex justify-content-center gap-5 p-5 pt-0">
    <div class="commit commit1" style="width: 416px; height: 416px;">
      <div class="commit-content">
        Hàng Chính Hãng - An toàn pháp lý - Chia sẻ lợi nhuận không giới hạn
      </div>
    </div>
    <div class="commit commit2" style="width: 416px; height: 416px;">
      <div class="commit-content">
        rủi ro bằng không - bảo hành bất chấp, đổi trả không cần lý do
      </div>
    </div>
    <div class="commit commit3" style="width: 416px; height: 416px;">
      <div class="commit-content">
        hệ thống vận hành nhanh chóng - an toàn - hiệu quả
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div style="max-width: 1440px; margin: auto; padding: 40px 48px;">
    <div class="caption">
      Ưu đãi khi đăng nhập
    </div>
    <div class="pt-5">
      <div class="row">
        <div class="col-6 d-flex h-auto">
          <div class="promo">
            <img src="assets/svg/landing-page/guarantee.svg"  loading="lazy" />
            <div class="d-flex flex-column" style="gap: 20px;">
              <div style="font-size: 32px; font-weight: 600; line-height: 130%; color: var(--theme-color);">
                Bảo hành bất chấp
              </div>
              <div style="font-size: 20px; line-height: 150%; color: #000000;">
                Nhận ngay chính sách <span style="font-weight: 700;">Bảo hành bất chấp - Đổi trả không cần lý do - Hết date vẫn nhận đổi trả</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 d-flex h-auto">
          <div class="promo reverse">
            <img src="assets/svg/landing-page/margin.svg"  loading="lazy" />
            <div class="d-flex flex-column text-end" style="gap: 20px;">
              <div style="font-size: 32px; font-weight: 600; line-height: 130%; color: var(--theme-color);">
                Chia sẻ lợi nhuận không giới hạn
              </div>
              <div style="font-size: 20px; line-height: 150%; color: #000000;">
                Tích xu với mọi giá trị đơn hàng - Đổi quà tặng với chiết khấu cực lớn
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row promo m-0 mt-4 position-relative" style="padding: 39px; height: 200px;">
        <div class="d-flex flex-column justify-content-center align-items-center" style="gap: 20px;">
          <div style="font-weight: 600; font-size: 32px; line-height: 130%; color: var(--theme-color); z-index: 1;">
            Bộ quà tặng tri ân khi đăng nhập
          </div>
          <div style="font-size: 20px; line-height: 150%; color: #000000;">
            <div>
              Nhận ngay <span style="font-weight: 700;">15.000 xu</span> khi đăng nhập tài khoản
            </div>
            <div>
              Nhận ngay <span style="font-weight: 700;">bộ quà tặng DV MedKing</span> trong giỏ quà
            </div>
          </div>
        </div>
        <img src="assets/svg/landing-page/appreciation.svg" class="position-absolute" style="right: 0; padding: 0; width: 325px; height: 200px;"  loading="lazy" />
      </div>

      <div class="d-flex justify-content-center pt-5">
        <button *ngIf="!isAuthenticated" class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">mở ưu đãi của tôi</button>
        <button *ngIf="isAuthenticated" class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="receiveReward()" data-cta="landing.welcome_back_claim" data-cta-loc="welcome_back">nhận ưu đãi</button>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div>
    <div style="max-width: 1440px; margin: auto; padding: 40px 48px;">
      <div class="d-flex justify-content-center pb-5">
        <div class="caption">
          Vì sao đối tác chọn dược vương - DV MedKing
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center p-0 mobile" style="gap: 12px;">
        <div *ngFor="let service of services; let last = last" class="d-flex" style="width: 280px; height: -webkit-fill-available;">
          <div class="promo" style="padding: 20px !important;">
            <div class="d-flex flex-column" style="padding: 25px 0; gap: 40px;">
              <img [src]="service.image_url" [alt]="service?.title" class="img-fluid m-auto"
                style="height: 80px; width: 80px;">
              <div class="d-flex flex-column text-center gap-1">
                <div class="text-theme fw-bold" style="font-size: 20px; line-height: 21.6px;">{{ service.title }}</div>
                <div style="font-size: 14px; line-height: 21.6px; color: #828282;">
                  {{ service.description}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div>
    <div style="padding: 40px 0;">
      <div class="caption d-flex justify-content-center pb-4">
        FAQ
      </div>

      <div class="d-flex flex-column gap-3 px-5" style="max-width: 1440px; margin: auto;">
        <div class="promo p-2" (click)="toggleAnswer('a1', 'img1')">
          <div class="d-flex align-items-start gap-2">
            <img id="img1" src="assets/svg/landing-page/chevron-forward.svg"  loading="lazy" />
            <div class="d-flex flex-column gap-2">
              <div class="title m-0">
                DV có chịu rủi ro giúp đối tác không?
              </div>
              <div id="a1">
                <ul class="d-flex flex-column gap-2" style="color: #828282;">
                  <li>
                    Có - DV MedKing chịu rủi ro thay khách hàng.
                  </li>
                  <li>
                    Đó là cam kết cốt lõi của chúng tôi
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="promo p-2" (click)="toggleAnswer('a2', 'img2')">
          <div class="d-flex align-items-start gap-2">
            <img id="img2" src="assets/svg/landing-page/chevron-forward.svg"  loading="lazy" />
            <div class="d-flex flex-column gap-2">
              <div class="title m-0">
                Tại sao tôi cần đăng nhập?
              </div>
              <div id="a2">
                <ul class="d-flex flex-column gap-2" style="color: #828282;">
                  <span>DV MedKing mong muốn:</span>
                  <li class="ms-4" style="display: list-item;">
                    Bảo mật thông tin tài khoản.
                  </li>
                  <li class="ms-4" style="display: list-item;">
                    Dành tặng ưu đãi riêng cho Quý Khách Hàng.
                  </li>
                  <li class="ms-4" style="display: list-item;">
                    Minh bạch trong: theo dõi đơn hàng, hóa đơn VAT, giao vận, dashboard.
                  </li>
                  <li class="ms-4" style="display: list-item;">
                    Trải nghiệm <span style="font-weight: 700;">Nhanh chóng - An toàn - Hiệu quả.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="promo p-2" (click)="toggleAnswer('a3', 'img3')">
          <div class="d-flex align-items-start gap-2">
            <img id="img3" src="assets/svg/landing-page/chevron-forward.svg"  loading="lazy" />
            <div class="d-flex flex-column gap-2">
              <div class="title m-0">
                Nếu tôi quên mật khẩu thì sao?
              </div>
              <div id="a3">
                <ul class="d-flex flex-column gap-2" style="color: #828282;">
                  <li>
                    DV MedKing khôi phục mật khẩu nhanh bằng email/SĐT trong vài bước.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="padding-top: 20px;">
    <div class="bottom bg-image">
      <div class="d-flex flex-column text-center" style="padding: 254px 0; gap: 32px; background-color: #00000080; color: #ffffff;">
        <div style="font-weight: 500; font-size: 48px; line-height: 52px;">
          Đừng bỏ lỡ ưu đãi dành riêng cho Quý Khách Hàng
        </div>
        <div style="font-size: 20px; line-height: 130%;">
          Chỉ cần đăng nhập - DV MedKing đồng hành và chịu mọi rủi ro để Quý Khách Hàng an tâm phát triển
        </div>
        <div>
          <button *ngIf="!isAuthenticated" class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">Đăng nhập</button>
          <button *ngIf="isAuthenticated" class="btn-login" style="font-size: 16px; text-transform: uppercase;" (click)="receiveReward()" data-cta="landing.welcome_back_claim" data-cta-loc="welcome_back">nhận ưu đãi</button>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="d-flex gap-5 px-5" style="max-width: 1440px; margin: auto;">
      <div class="d-flex flex-column justify-content-between" style="width: 540px;">
        <img src="https://s3.ap-southeast-1.amazonaws.com/ecrms-appfiles/homeconfig/configuration/20251212_022718_587.webp" style="max-width: 162px;"  loading="lazy" />
        <div style="font-size: 14px; color: #ffffff; font-style: italic; line-height: 20px;">
          Bản quyền © Dược Vương
        </div>
      </div>
      <div class="d-flex flex-column gap-3" style="line-height: 20px; color: #ffffff; text-transform: capitalize;">
        <div type="button" style="font-weight: 700; font-size: 16px;" (click)="goto('dieu-khoan-su-dung')">
          Điều khoản & Chính sách
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('dieu-khoan-su-dung')">
          Chính sách sử dụng
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('chinh-sach-bao-mat')">
          Chính sách bảo mật
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('dat-hang-nhanh-nhan-hang-ngay')">
          Chính sách vận chuyển
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('chinh-sach-giai-quyet-khieu-nai')">
          Chính sách giải quyết khiếu nại
        </div>
      </div>
      <div class="d-flex flex-column gap-3 flex-grow-1" style="line-height: 20px; color: #ffffff; text-transform: capitalize;">
        <div style="font-weight: 700; font-size: 16px;">
          Liên hệ với chúng tôi
        </div>
        <div class="d-flex gap-2 align-items-start">
          <img src="assets/svg/landing-page/phone.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-1">
            <div style="line-height: 20px; font-size: 15px;">Hotline Miền Bắc 24/7</div>
            <div style="line-height: 20px; font-size: 15px;">0878.929.789</div>
          </div>
        </div>
        <div class="d-flex gap-2 align-items-start">
          <img src="assets/svg/landing-page/phone.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-1">
            <div style="line-height: 20px; font-size: 15px;">Hotline Miền Nam 24/7</div>
            <div style="line-height: 20px; font-size: 15px;">0822.66.2024</div>
          </div>
        </div>
        <div class="d-flex" style="gap: 20px;">
          <img src="assets/svg/landing-page/fb-icon.svg"  loading="lazy" />
          <img src="assets/svg/landing-page/zalo-icon.svg"  loading="lazy" />
        </div>
      </div>
      <div class="d-flex flex-column gap-3" style="line-height: 20px; color: #ffffff; text-transform: capitalize; margin-right: 80px;">
        <div style="font-weight: 700; font-size: 16px;">
          Tải app ngay
        </div>
        <div>
          <a href="https://play.google.com/store/apps/details?id=com.gtt&hl=vi" target="_blank"><img src="assets/images/home/google_download.svg" alt="playstore"  loading="lazy" /></a>
        </div>
        <div>
          <a href="https://apps.apple.com/vn/app/gi%C3%A1-thu%E1%BB%91c-t%E1%BB%91t/id6648759606?uo=2" target="_blank"><img src="assets/images/home/apple_download.svg" alt="appstore"  loading="lazy" /></a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none">
  <div style="background-color: var(--theme-color);">
    <div class="d-flex justify-content-between align-items-center" style="padding: 12px 16px;">
      <img src="https://s3.ap-southeast-1.amazonaws.com/ecrms-appfiles/homeconfig/configuration/20251212_022718_587.webp" style="max-height: 40px;"  loading="lazy" />
      <div *ngIf="!isAuthenticated">
        <button class="btn-login" style="font-size: 14px;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">Đăng nhập</button>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column gap-4" style="padding: 24px 16px;">
    <div style="font-weight: 700; font-size: 36px; line-height: 130%; color: #000000;">
      <div>Chào mừng</div>
      <div>Quý Khách Hàng</div>
      <div>quay trở lại</div>
    </div>
    <div style="font-size: 20px; color: #828282; line-height: 150%;">
      Trải nghiệm <span style="font-weight: 700;">Nhanh chóng – An toàn – Hiệu quả</span> cùng Dược Vương – DV Medking. 
    </div>
    <div>
      <button *ngIf="!isAuthenticated" class="btn-login w-100" style="font-size: 14px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">Đăng nhập</button>
      <button *ngIf="isAuthenticated" class="btn-login w-100" style="font-size: 14px; text-transform: uppercase;" (click)="receiveReward()" data-cta="landing.welcome_back_claim" data-cta-loc="welcome_back">nhận ưu đãi</button>
    </div>
    <div>
      <img src="assets/images/landing-page/welcome-back-illustration.png" class="img-fluid m-auto"  loading="lazy" />
    </div>
  </div>

  <div style="padding: 20px 0;">
    <div style="padding: 40px 16px; background-color: var(--theme-color)26; border: 1px solid var(--theme-color)4D; font-size: 14px; line-height: 140%; font-style: italic; text-align: center;">
      Dược Vương - DV MedKing xin gửi lời tri ân chân thành đến Quý khách hàng, những người đã đồng hành, tin tưởng và trao cho chúng tôi cơ hội được phục vụ để cùng nhau lan tỏa sức khỏe và niềm vui đến cộng đồng. Với khát vọng mang đến cho Quý vị những giá trị vượt xa mong đợi, DV MedKing hôm nay đã nhanh hơn, an toàn hơn, hiệu quả hơn.
    </div>
  </div>

  <div style="padding: 24px 16px; display: flex; justify-content: center; font-size: 24px; font-weight: 500; line-height: 130%;">
    Như một lời tri ân dành cho Quý Khách Hàng, DV MedKing cam kết: 
  </div>

  <div class="d-flex flex-column gap-3 overflow-auto" style="padding: 0 16px 24px;">
    <div class="commit commit1" style="aspect-ratio: 1;">
      <div class="commit-content" style="font-size: 24px;">
        Hàng Chính Hãng - An toàn pháp lý - Chia sẻ lợi nhuận không giới hạn
      </div>
    </div>
    <div class="commit commit2" style="aspect-ratio: 1;">
      <div class="commit-content" style="font-size: 24px;">
        rủi ro bằng không - bảo hành bất chấp, đổi trả không cần lý do
      </div>
    </div>
    <div class="commit commit3" style="aspect-ratio: 1;">
      <div class="commit-content" style="font-size: 24px;">
        hệ thống vận hành nhanh chóng - an toàn - hiệu quả
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div style="padding: 24px 16px;">
    <div class="caption pb-5" style="font-size: 32px;">
      Ưu đãi khi đăng nhập
    </div>
    <div class="d-flex flex-column gap-3">
      <div class="promo flex-column gap-0 p-3">
        <img src="assets/svg/landing-page/guarantee.svg"  loading="lazy" />
        <div class="d-flex flex-column" style="gap: 16px; padding-top: 30px;">
          <div style="font-size: 24px; font-weight: 600; line-height: 130%; color: var(--theme-color);">
            Bảo hành bất chấp
          </div>
          <div style="font-size: 16px; line-height: 150%; color: #000000;">
            Nhận ngay chính sách <span style="font-weight: 700;">Bảo hành bất chấp - Đổi trả không cần lý do - Hết date vẫn nhận đổi trả</span>
          </div>
        </div>
      </div>
      <div class="promo flex-column gap-0 p-3">
        <img src="assets/svg/landing-page/margin.svg"  loading="lazy" />
        <div class="d-flex flex-column" style="gap: 16px; padding-top: 30px;">
          <div style="font-size: 24px; font-weight: 600; line-height: 130%; color: var(--theme-color);">
            Chia sẻ lợi nhuận không giới hạn
          </div>
          <div style="font-size: 16px; line-height: 150%; color: #000000;">
            Tích xu với mọi giá trị đơn hàng - Đổi quà tặng với chiết khấu cực lớn
          </div>
        </div>
      </div>
      <div class="promo flex-column gap-0 p-3">
        <img src="assets/svg/landing-page/appreciation1.svg"  loading="lazy" />
        <div class="d-flex flex-column" style="gap: 16px; padding-top: 30px;">
          <div style="font-size: 24px; font-weight: 600; line-height: 130%; color: var(--theme-color);">
            Bộ quà tặng tri ân khi đăng nhập
          </div>
          <div style="font-size: 16px; line-height: 150%; color: #000000;">
            Nhận ngay <span style="font-weight: 700;">15.000 xu</span> khi đăng nhập tài khoản
          </div>
        </div>
      </div>
    </div>
    <button *ngIf="!isAuthenticated" class="btn-login mt-5 w-100" style="font-size: 14px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">mở ưu đãi của tôi</button>
    <button *ngIf="isAuthenticated" class="btn-login mt-5 w-100" style="font-size: 14px; text-transform: uppercase;" (click)="receiveReward()" data-cta="landing.welcome_back_claim" data-cta-loc="welcome_back">nhận ưu đãi</button>
  </div>

  <div class="divider"></div>

  <div style="padding: 20px 16px;">
    <div class="d-flex justify-content-center pb-5">
      <div class="caption" style="font-size: 32px;">
        Vì sao đối tác chọn dược vương - DV MedKing
      </div>
    </div>

    <div class="d-md-none">
      <div class="d-flex flex-column align-items-center p-0" style="gap: 12px;">
        <div *ngFor="let service of services; let last = last" class="d-flex w-100" style="aspect-ratio: 1;">
          <div class="promo w-100" style="padding: 20px !important;">
            <div class="d-flex flex-column w-100" style="padding: 25px 0; gap: 40px;">
              <img [src]="service.image_url" [alt]="service?.title" class="img-fluid m-auto"
                style="height: 80px; width: 80px;">
              <div class="d-flex flex-column text-center gap-1">
                <div class="text-theme fw-bold" style="font-size: 20px; line-height: 21.6px;">{{ service.title }}</div>
                <div style="font-size: 14px; line-height: 21.6px; color: #828282;">
                  {{ service.description}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-none d-md-block">
      <div class="row g-3 justify-content-center">
        <div *ngFor="let service of services; let last = last" class="col-4 d-flex" style="aspect-ratio: 1;">
          <div class="promo w-100" style="padding: 20px !important;">
            <div class="d-flex flex-column w-100" style="padding: 25px 0; gap: 40px;">
              <img [src]="service.image_url" [alt]="service?.title" class="img-fluid m-auto"
                style="height: 80px; width: 80px;">
              <div class="d-flex flex-column text-center gap-1">
                <div class="text-theme fw-bold" style="font-size: 20px; line-height: 21.6px;">{{ service.title }}</div>
                <div style="font-size: 14px; line-height: 21.6px; color: #828282;">
                  {{ service.description}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div style="padding: 0px 16px;">
    <div class="caption d-flex justify-content-center pb-4" style="font-size: 32px;">
      FAQ
    </div>

    <div class="d-flex flex-column gap-3">
      <div class="promo p-2" (click)="toggleAnswer('m-a1', 'm-img1')">
        <div class="d-flex align-items-start gap-2">
          <img id="m-img1" src="assets/svg/landing-page/chevron-forward.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-2">
            <div class="title m-0">
              DV có chịu rủi ro giúp đối tác không?
            </div>
            <div id="m-a1">
              <ul class="d-flex flex-column gap-2" style="color: #828282;">
                <li>
                  Có - DV MedKing chịu rủi ro thay khách hàng.
                </li>
                <li>
                  Đó là cam kết cốt lõi của chúng tôi
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="promo p-2" (click)="toggleAnswer('m-a2', 'm-img2')">
        <div class="d-flex align-items-start gap-2">
          <img id="m-img2" src="assets/svg/landing-page/chevron-forward.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-2">
            <div class="title m-0">
              Tại sao tôi cần đăng nhập?
            </div>
            <div id="m-a2">
              <ul class="d-flex flex-column gap-2" style="color: #828282;">
                <span>DV MedKing mong muốn:</span>
                <li class="ms-4" style="display: list-item;">
                  Bảo mật thông tin tài khoản.
                </li>
                <li class="ms-4" style="display: list-item;">
                  Dành tặng ưu đãi riêng cho Quý Khách Hàng.
                </li>
                <li class="ms-4" style="display: list-item;">
                  Minh bạch trong: theo dõi đơn hàng, hóa đơn VAT, giao vận, dashboard.
                </li>
                <li class="ms-4" style="display: list-item;">
                  Trải nghiệm <span style="font-weight: 700;">Nhanh chóng - An toàn - Hiệu quả.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="promo p-2" (click)="toggleAnswer('m-a3', 'm-img3')">
        <div class="d-flex align-items-start gap-2">
          <img id="m-img3" src="assets/svg/landing-page/chevron-forward.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-2">
            <div class="title m-0">
              Nếu tôi quên mật khẩu thì sao?
            </div>
            <div id="m-a3">
              <ul class="d-flex flex-column gap-2" style="color: #828282;">
                <li>
                  DV MedKing khôi phục mật khẩu nhanh bằng email/SĐT trong vài bước.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="padding-top: 20px;">
    <div class="bottom">
      <div class="d-flex flex-column text-center" style="padding: 198.5px 16px; gap: 32px; background-color: #00000080; color: #ffffff;">
        <div style="font-weight: 500; font-size: 32px; line-height: 140%;">
          Đừng bỏ lỡ ưu đãi dành riêng cho Quý Khách Hàng
        </div>
        <div style="font-size: 14px; line-height: 130%;">
          Chỉ cần đăng nhập - DV MedKing đồng hành và chịu mọi rủi ro để Quý Khách Hàng an tâm phát triển
        </div>
        <div>
          <button *ngIf="!isAuthenticated" class="btn-login w-100" style="font-size: 14px; text-transform: uppercase;" (click)="openLoginModal()" data-cta="landing.welcome_back_login" data-cta-loc="welcome_back">Đăng nhập</button>
          <button *ngIf="isAuthenticated" class="btn-login w-100" style="font-size: 14px; text-transform: uppercase;" (click)="receiveReward()" data-cta="landing.welcome_back_claim" data-cta-loc="welcome_back">nhận ưu đãi</button>
        </div>
      </div>
    </div>
  </div>

  <div class="px-3 py-4" style="background-color: var(--theme-color);">
    <div class="d-flex flex-column" style="gap: 60px;">
      <img src="https://s3.ap-southeast-1.amazonaws.com/ecrms-appfiles/homeconfig/configuration/20251212_022718_587.webp" style="max-width: 162px;"  loading="lazy" />

      <div class="d-flex flex-column gap-3" style="line-height: 20px; color: #ffffff; text-transform: capitalize;">
        <div type="button" style="font-weight: 700; font-size: 16px;" (click)="goto('dieu-khoan-su-dung')">
          Điều khoản & Chính sách
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('dieu-khoan-su-dung')">
          Chính sách sử dụng
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('chinh-sach-bao-mat')">
          Chính sách bảo mật
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('dat-hang-nhanh-nhan-hang-ngay')">
          Chính sách vận chuyển
        </div>
        <div type="button" style="font-size: 15px;" (click)="goto('chinh-sach-giai-quyet-khieu-nai')">
          Chính sách giải quyết khiếu nại
        </div>
      </div>

      <div class="d-flex flex-column gap-3" style="line-height: 20px; color: #ffffff; text-transform: capitalize;">
        <div style="font-weight: 700; font-size: 16px;">
          Liên hệ với chúng tôi
        </div>
        <div class="d-flex gap-2 align-items-start">
          <img src="assets/svg/landing-page/phone.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-1">
            <div style="line-height: 20px; font-size: 15px;">Hotline Miền Bắc 24/7</div>
            <div style="line-height: 20px; font-size: 15px;">0878.929.789</div>
          </div>
        </div>
        <div class="d-flex gap-2 align-items-start">
          <img src="assets/svg/landing-page/phone.svg"  loading="lazy" />
          <div class="d-flex flex-column gap-1">
            <div style="line-height: 20px; font-size: 15px;">Hotline Miền Nam 24/7</div>
            <div style="line-height: 20px; font-size: 15px;">0822.66.2024</div>
          </div>
        </div>
        <div class="d-flex" style="gap: 20px;">
          <img src="assets/svg/landing-page/fb-icon.svg"  loading="lazy" />
          <img src="assets/svg/landing-page/zalo-icon.svg"  loading="lazy" />
        </div>
      </div>

      <div class="d-flex flex-column gap-3" style="line-height: 20px; color: #ffffff; text-transform: capitalize; margin-right: 80px;">
        <div style="font-weight: 700; font-size: 16px;">
          Tải app ngay
        </div>
        <div>
          <a href="https://play.google.com/store/apps/details?id=com.gtt&hl=vi" target="_blank"><img src="assets/images/home/google_download.svg" alt="playstore"  loading="lazy" /></a>
        </div>
        <div>
          <a href="https://apps.apple.com/vn/app/gi%C3%A1-thu%E1%BB%91c-t%E1%BB%91t/id6648759606?uo=2" target="_blank"><img src="assets/images/home/apple_download.svg" alt="appstore"  loading="lazy" /></a>
        </div>
      </div>

      <div style="font-size: 14px; color: #ffffff; font-style: italic; line-height: 20px;">
        Bản quyền © Dược Vương
      </div>
    </div>
  </div>
</div>

<app-login-modal #loginModal [fromWelcomeBack]="true" [campainType]="1"></app-login-modal>
